import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import type { QIllustrationName } from 'app-components/assets/QIllustration/qIllustrationLoaders';
import QIllustration from 'components/QIllustration';

type ConnectionUpdateIconVariant = 'default' | 'banner' | 'account-row';

const illustrations = {
  default: { light: 'fiMigrationUpdate', dark: 'fiMigrationUpdateDark' },
  banner: { light: 'fiMigrationBanner', dark: 'fiMigrationBannerDark' },
  'account-row': { light: 'fiMigrationAccountRow', dark: 'fiMigrationAccountRowDark' },
  neutral: { light: 'fiMigrationMenu', dark: 'fiMigrationMenuDark' },
} satisfies Record<ConnectionUpdateIconVariant | 'neutral', Record<'light' | 'dark', QIllustrationName>>;

/** The connection upgrade glyph shared by banners, account rows, and account discovery. */
export default function ConnectionUpdateIcon({
  size = 20,
  tone = 'primary',
  variant = 'default',
}: {
  size?: number;
  tone?: 'primary' | 'neutral';
  variant?: ConnectionUpdateIconVariant;
}): React.JSX.Element {
  const { mode } = useTheme().palette;
  const name = illustrations[tone === 'neutral' ? 'neutral' : variant][mode];
  return (
    <Box aria-hidden sx={{ display: 'flex', flexShrink: 0, width: size, height: size }}>
      <QIllustration name={name} width={size} height={size} alt='' />
    </Box>
  );
}
